import React from "react";
import { Body, Label } from "../../../../components/Typography";
import { OrderDetailCard, CardSection } from "./OrderDetailCard";
import { PaymentLink } from "./PaymentLink";
import { PricingBreakdown } from "./PaymentCard";
import { formatOrderDate, getMostRecentRefund, type Order } from "./shared";

export const RefundCard: React.FC<{ order: Order }> = ({ order }) => {
  const refunds = order.refunds ?? [];
  if (refunds.length === 0) return null;

  const mostRecentRefund = getMostRecentRefund(refunds);

  return (
    <OrderDetailCard>
      <CardSection>
        <Label>Refund</Label>
        <Body>
          Full Refund
          {mostRecentRefund?.createdAt && <> on {formatOrderDate(mostRecentRefund.createdAt)}</>}
          {mostRecentRefund?.id != null && <PaymentLink paymentId={mostRecentRefund.id} />}
        </Body>
      </CardSection>

      {order.pricing && <PricingBreakdown pricing={order.pricing} label="Total Refund Amount" prefix="- " />}
    </OrderDetailCard>
  );
};
